import React, { Component } from "react";
import _ from "lodash";
import { NavLink } from "react-router-dom";
import {reportsInitNav} from "../../store/config";

export default class ReportsSubnav extends Component {
	render() {
		let { params, reports } = this.props;
		let { financial, expenses, employees, summary } = reports;
		return <div className="subnavigation-projects" style={{height: financial.isFetching || expenses.isFetching || employees.isFetching || summary.isFetching ? '80px':'auto'}}>
			<div className="level">
				<div className="level-item subnav-section">
					<div className="details">
						<h4>{params.modality === 'modalidad-i' ? 'Categoría A' : (params.modality === 'modalidad-ii' ? 'Modalidad II' : 'Modalidad III')}</h4>
					</div>
				</div>
				<div className="level-item subnav-step">
					<div className="details">
						{reportsInitNav ?
							<div className="level context-navigation">
								{_.map(reportsInitNav,(item, k) => {
									let reportLink = _.replace(_.replace(_.replace(_.replace(item.url, ':modality', params.modality), ':state?', params.state === 'undefined' ? params.municipalities[0].state.short : params.state), ':municipality?', params.municipality === null ? params.municipalities[0].slug : params.municipality), 'undefined', '');

									return (
										<div className="level-item" key={k}>
											<NavLink className="step" to={reportLink} activeClassName="active">
												<p>{item.step}</p>
												<span>{item.title}</span>
											</NavLink>
										</div>
									);
								})}
							</div> : ''}
					</div>
				</div>
			</div>
		</div>
	}
}


// WEBPACK FOOTER //
// ./src/elements/navigation/reports-subnav.jsx